var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6177 4.03434L6.81032 1.25879L2.00293 4.03434V9.58543L6.81032 12.361L11.6177 9.58543V4.03434ZM6.81032 8.66025C7.83225 8.66025 8.66068 7.83181 8.66068 6.80988C8.66068 5.78796 7.83225 4.95952 6.81032 4.95952C5.78839 4.95952 4.95995 5.78796 4.95995 6.80988C4.95995 7.83181 5.78839 8.66025 6.81032 8.66025Z",
    stroke: "black",
    strokeWidth: 0.948905,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.e4dbecaf2d8324e2b9125ca2851580e9.svg";
export { ForwardRef as ReactComponent };